var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#0000BB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480-212.31 240-342.77v-193.85L123.08-600 480-793.85 836.92-600v255.39h-40v-232.93L720-536.62v193.85L480-212.31ZM480-452l273.23-148L480-748 206.77-600 480-452Zm0 194.08 200-108v-148.7L480-406.3 280-514.62v148.7l200 108ZM480-452Zm0 54.62Zm0 0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSchoolIcon);
export default __webpack_public_path__ + "static/media/marker-school-icon.ed3993a588fb2f8e296f7acf07ead99d.svg";
export { ForwardRef as ReactComponent };